<template>
    <rkm-area
        :closed="closed"
        background-color="primary"
        title="Triagem de Risco Alimentar (TRIA)"
        type="box"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-radio-group
                    label="Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida?"
                    v-model="data.model.tria.alimentosAcabaram"
                    :validations="validations.alimentosAcabaram"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                    <rkm-form-radio :value="null">Não informado</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="12">
                <rkm-form-radio-group
                    label="Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou?"
                    v-model="data.model.tria.comeuAlgunsAlimentos"
                    :validations="validations.comeuAlgunsAlimentos"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                    <rkm-form-radio :value="null">Não informado</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Data de atualização"
                    v-model="data.model.tria.dataAtualizacaoTria"
                    disabled
                    right
                />
            </rkm-col>

            <rkm-col
                v-if="isTriaDesatualizado"
                cols="12"
            >
                <rkm-alert
                    class="mb-0"
                    color="warning"
                >
                    TRIA sem atualização nos últimos 3 meses. Revise as informações antes de finalizar o atendimento.
                </rkm-alert>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
export default {
    computed: {
        isTriaDesatualizado() {
            return Boolean(this.data?.form?.tria?.isDesatualizado)
        },
        validations() {
            return {
                alimentosAcabaram: {
                    required: this.data.model.tria.comeuAlgunsAlimentos !== null
                },
                comeuAlgunsAlimentos: {
                    required: this.data.model.tria.alimentosAcabaram !== null
                },
            }
        }
    },
    props: {
        closed: {type: Boolean, default: false},
        data: {type: Object, required: true},
    },
}
</script>